export default {
  批量添加到客户库: '批量添加到客户库',
  拍照识别: '拍照识别',
  自主创建: '自主创建',
  群组描述不能为空: '群组描述不能为空',
  群组名称不能为空: '群组名称不能为空',
  我的群组: '我的群组',
  请选择群组: '请选择群组',
  条数据: '条数据',
  个云数据: '个云数据',
  全选: '全选',
  取消选择: '取消选择',
  添加客户库: '添加客户库',
  您的潜在客户: '您的潜在客户',
  累计触达客户量: '累计触达客户量',
  涵盖行业提示: '涵盖行业 / 个',
  公海客户数量提示1: '公海客户数量 / 个',
  客户数量: '客户数量',
  客户新增: '新增云数据',
  触达客户量: '触达客户量',
  添加成功: '添加成功!',
  云数据提示1: '请输入企业名/经营范围',
  企业名或经营范围: '企业名或经营范围',
  客户详情: '客户详情',
  企业税号: '企业税号',
  邮编: '邮编',
  企业官网: '企业官网',
  企业所在地: '企业所在地',
  经营范围: '经营范围',
  客户来源: '客户来源',
  区域: '区域',
  请输入企业名称: '请输入企业名称/联系人',
  云数据提示语: '挑选意向客户,添加客户库,进而一键短信邀约,赢得宝贵订单',
  企业数据: '企业数据',
  行业: '行业',
  '100万以内': '100万以内',
  '100-200万': '100-200万',
  '200-500万': '200-500万',
  '500-1000万': '500-1000万',
  '1000-5000万': '1000-5000万',
  '5000万以上': '5000万以上',
  '1年内': '1年内',
  '1-3年': '1-3年',
  '3-5年': '3-5年',
  '5-10年': '5-10年',
  '10-30年': '10-30年',
  '30年以上': '30年以上',
}
